<template>
    <layouts-header></layouts-header>

    <cage-breadcrumb :title="title" :text="text" :text1="text1" />

    <coach-tabset></coach-tabset>

    <!-- Page Content -->
    <div class="content">
        <div class="container">
            <section class="card mb-40">
                <div class="text-center mb-40">
                    <h3 class="mb-1">Time & Date</h3>
                    <p class="sub-title">Book your training session at a time and date that suits your needs.</p>
                </div>
                <div class="master-academy dull-whitesmoke-bg card">
                    <div class="d-sm-flex justify-content-between align-items-center">
                        <div class="d-sm-flex justify-content-start align-items-center">
                            <a href="javascript:void(0);"><img class="corner-radius-10"
                                    src="@/assets/img/profiles/avatar-02.png" alt="User"></a>
                            <div class="info">
                                <div class="d-flex justify-content-start align-items-center mb-3">
                                    <span
                                        class="text-white dark-yellow-bg color-white me-2 d-flex justify-content-center align-items-center">4.5</span>
                                    <span>300 Reviews</span>
                                </div>
                                <h3 class="mb-2">Kevin Anderson</h3>
                                <p>Certified Badminton Coach with a deep understanding of the sport's strategies.</p>
                            </div>
                        </div>
                        <div class="white-bg">
                            <p class="mb-1">Starts From</p>
                            <h3 class="d-inline-block primary-text mb-0">$150</h3><span>/hr</span>
                        </div>
                    </div>
                </div>
            </section>
            <div class="row text-center">
                <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                    <div class="card time-date-card">
                        <section class="booking-date">
                            <div class="list-unstyled owl-carousel date-slider owl-theme mb-40">
                                <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
                                    <Slide v-for="item in CoachTimedate" :key="item.id">
                                        <div class="booking-date-item">
                                            <h6>{{ item.Day }}</h6>
                                            <p>{{ item.Date }}</p>
                                        </div>
                                    </Slide>
                                    <template #addons>
                                        <Navigation />
                                    </template>
                                </Carousel>
                            </div>
                            <div class="row">
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot">
                                        <span>2:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot">
                                        <span>2:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot">
                                        <span>2:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot">
                                        <span>2:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot">
                                        <span>3:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot">
                                        <span>3:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot">
                                        <span>3:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot">
                                        <span>3:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot">
                                        <span>4:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot">
                                        <span>4:00 PM<i class="fa-regular fa-check-circle"></i></span>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot">
                                        <span>4:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot">
                                        <span>4:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot">
                                        <span>5:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot">
                                        <span>5:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot active checked">
                                        <span>5:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot">
                                        <span>5:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot active">
                                        <span>6:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot active">
                                        <span>6:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot active checked">
                                        <span>6:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot active">
                                        <span>6:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot active">
                                        <span>7:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot active">
                                        <span>7:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot active checked">
                                        <span>7:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-4 col-md-3">
                                    <div class="time-slot active">
                                        <span>7:00 PM</span><i class="fa-regular fa-check-circle"></i>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                    <aside class="card booking-details">
                        <h3 class="border-bottom">Booking Details</h3>
                        <ul>
                            <li><i class="feather-calendar me-2"></i>27, April 2023</li>
                            <li><i class="feather-clock me-2"></i>05:00 PM to 07:00 PM</li>
                            <li><i class="feather-clock me-2"></i>Total Hour : 3 Hrs</li>
                        </ul>
                        <div class="d-grid btn-block">
                            <button type="button" class="btn btn-primary">Subtotal : $200</button>
                        </div>
                    </aside>
                </div>
            </div>
            <div class="text-center btn-row">
                <router-link class="btn btn-primary me-3 btn-icon" to="/coaches/coach-details"><i
                        class="feather-arrow-left-circle me-1"></i> Back</router-link>
                <router-link class="btn btn-secondary btn-icon" to="/coaches/coach-personalinfo">Next <i
                        class="feather-arrow-right-circle ms-1"></i></router-link>
            </div>
        </div>
        <!-- /Container -->
    </div>
    <!-- /Page Content -->

    <layout-footer></layout-footer>
</template>

<script>
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import CoachTimedate from '@/assets/json/coach-timedate.json'
export default {
    data() {
        return {
            CoachTimedate: CoachTimedate,
            title: 'Book A Coach',
            text: 'Home',
            text1: 'Book A Coach',
            settings: {
                itemsToShow: 1,
                snapAlign: "center",
            },
            breakpoints: {
                575: {
                    itemsToShow: 2,
                    snapAlign: "center",
                },
                767: {
                    itemsToShow: 3,
                    snapAlign: "center",
                },
                991: {
                    itemsToShow: 3,
                    snapAlign: "center",
                },
                1024: {
                    itemsToShow: 4,
                    snapAlign: "start",
                },
            },
        }
    },
    components: {
        Carousel,
        Slide,
        Navigation,
        Pagination
    },
}
</script>